import React from 'react'
import './index.scss'
import Waterfall from "./waterfall/index";

// 我们的团队
const Gallery = (props) => {
  //
  return [{
    uid: 'gallery-1',
    html:(
      <div className="section-gallery gallery-full">
        <div className="container">
          <h2 className="section-title">{props.title.content}</h2>
          <div className="section-gallery-list">
            <div id="carousel-gallery-1" className="carousel slide" data-ride="carousel">
              <div className="carousel-inner" role="listbox">
                {props.media.items.map((media, index) =>
                  <div className={"item" + (index === 0 ? ' active' : '') } key={index}>
                    <div className="gallery-item">
                      <img src={media.src} />
                    </div>
                  </div>
                )}
              </div>

              <a className="left carousel-control" href="#carousel-gallery-1" role="button" data-slide="prev">
                <span className="carousel-button fi fi-angle-left fi-2x" aria-hidden="true"> </span>
                <span className="sr-only">Previous</span>
              </a>

              <a className="right carousel-control" href="#carousel-gallery-1" role="button" data-slide="next">
                <span className="carousel-button fi fi-angle-right fi-2x" aria-hidden="true"> </span>
                <span className="sr-only">Next</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }, {
    uid: 'gallery-2',
    html:(
      <div className="section-gallery gallery-waterfall">
        <div className="container">
          <h2 className="section-title">{props.title.content}</h2>

          <Waterfall images={props.media.items} />
        </div>
      </div>
    )
  }, {
    uid: 'gallery-barrel',
    html: (
      <div className="section-gallery section-gallery-barrel">
        <div className="container">
          <h2 className="section-title">{props.title.content}</h2>
          <div className="gallery-barrel-list">
            {props.media.items.map((media, index) =>
              <div className="gallery-barrel-item"
                   style={{width: media.width * 200 / media.height}}
                   key={"gallery-barrel-" + index}>
                <img className="gallery-barrel-image"
                     alt={media.alt}
                     title={media.title}
                     src={media.src + "?imageMogr2/thumbnail/800x>"} />
                <div className="gallery-barrel-info">{media.description || media.title}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }]
}

export default Gallery


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/gallery/index.js